export interface Course {
    id: number;
    title: string;
    category: string;
    price: number;
    lessons: number;
    duration: string;
    image: string;
    description: string;
    whatYouWillLearn: string[];
    extraFacilities: { icon: string; text: string }[];
    instructor: {
        name: string;
        title: string;
        bio: string;
        image: string;
        socials?: {
            facebook?: string;
            instagram?: string;
            twitter?: string;
            linkedin?: string;
        };
    };
    level: string;
    language: string;
}

const courses: Course[] = [
    {
        id: 1,
        title: "Modern Web Geliştirme Bootcamp 2025",
        category: "Yazılım Geliştirme",
        price: 1499, // ₺
        lessons: 24,
        duration: "18 saat",
        image: require("@/assets/img/all-img/c1.png"),
        description:
            "HTML5, CSS3, JavaScript (ES6+) ve modern frontend frameworkleri (React & Vue) ile sıfırdan profesyonel web geliştirmeyi öğren. Proje bazlı içeriklerle gerçek dünya uygulamaları geliştir.",
        whatYouWillLearn: [
            "HTML5 & CSS3 ile güçlü web sayfaları geliştirme",
            "JavaScript (ES6+) modern sözdizimi ve pratikleri",
            "React.js ve Vue.js ile komponent tabanlı frontend geliştirme",
            "REST API entegrasyonu ve veri yönetimi",
            "Responsive ve mobil uyumlu tasarımlar",
        ],
        extraFacilities: [
            { icon: require("@/assets/img/icon/laptop.svg"), text: "Bilgisayar / Mobil" },
            { icon: require("@/assets/img/icon/pencil.svg"), text: "Not Defteri & Kalem" },
            { icon: require("@/assets/img/icon/wifi.svg"), text: "İnternet Bağlantısı" },
        ],
        instructor: {
            name: "Ali Çoban",
            title: "Yazılım Geliştirici",
            bio: "5+ yıllık deneyime sahip, modern web teknolojileri üzerine uzmanlaşmış bir yazılım geliştirici.",
            image: require("@/assets/img/all-img/team5.png"),
            socials: {
                facebook: "#",
                instagram: "#",
                twitter: "#",
                linkedin: "#",
            },
        },
        level: "Başlangıçtan İleri Seviye",  
        language: "Türkçe",                  
    },
    {
        id: 2,
        title: "Java Spring Boot ile Backend Geliştirme",
        category: "Backend Programlama",
        price: 1799, // ₺
        lessons: 28,
        duration: "22 saat",
        image: require("@/assets/img/all-img/c2.png"),
        description:
            "Java 21 ve Spring Boot 3 ile güçlü backend uygulamaları geliştirmeyi öğren. REST API tasarımı, güvenlik, JWT, veritabanı entegrasyonu ve mikroservis mimarisi odaklı kapsamlı içerik.",
        whatYouWillLearn: [
            "Spring Boot 3 ile RESTful API geliştirme",
            "Spring Security & JWT ile kimlik doğrulama",
            "MySQL & PostgreSQL veritabanı bağlantısı",
            "Mikroservis mimarisi ve servisler arası iletişim",
            "Docker ile container tabanlı deployment",
        ],
        extraFacilities: [
            { icon: require("@/assets/img/icon/laptop.svg"), text: "Bilgisayar / Mobil" },
            { icon: require("@/assets/img/icon/pencil.svg"), text: "Not Defteri & Kalem" },
            { icon: require("@/assets/img/icon/wifi.svg"), text: "İnternet Bağlantısı" },
        ],
        instructor: {
            name: "Bedirhan Güven",
            title: "Head of Engineering, Paycell",
            bio: "10+ yıllık deneyime sahip, büyük ölçekli sistemlerde backend mimarisi konusunda uzman.",
            image: require("@/assets/img/all-img/bedirhanguven.png"),
            socials: {
                facebook: "#",
                instagram: "#",
                twitter: "#",
                linkedin: "#",
            },
        },
        level: "Orta Seviye",
        language: "Türkçe",
    },
    {
        id: 3,
        title: "Python ile Veri Bilimi ve Yapay Zekâ",
        category: "Veri Bilimi & AI",
        price: 1999,
        lessons: 30,
        duration: "26 saat",
        image: require("@/assets/img/all-img/c3.png"),
        description:
            "Python, NumPy, Pandas, Matplotlib, Scikit-Learn ve TensorFlow ile veri analizi ve yapay zekâ modelleme öğren. Proje odaklı içeriklerle makine öğrenmesi ve derin öğrenmeye giriş yap.",
        whatYouWillLearn: [
            "Python ile veri işleme ve analiz",
            "NumPy ve Pandas kütüphaneleri ile veri manipülasyonu",
            "Matplotlib ve Seaborn ile veri görselleştirme",
            "Scikit-Learn ile makine öğrenmesi algoritmaları",
            "TensorFlow ile yapay sinir ağları ve derin öğrenme",
        ],
        extraFacilities: [
            { icon: require("@/assets/img/icon/laptop.svg"), text: "Bilgisayar / Mobil" },
            { icon: require("@/assets/img/icon/pencil.svg"), text: "Not Defteri & Kalem" },
            { icon: require("@/assets/img/icon/wifi.svg"), text: "İnternet Bağlantısı" },
        ],
        instructor: {
            name: "Ayşe Yılmaz",
            title: "Veri Bilimci",
            bio: "Akademik ve endüstri deneyimine sahip, veri analizi ve yapay zekâ alanında uzman eğitmen.",
            image: require("@/assets/img/all-img/team6.png"),
            socials: {
                facebook: "#",
                instagram: "#",
                twitter: "#",
                linkedin: "#",
            },
        },
        level: "İleri Seviye",
        language: "Türkçe",
    },
];

export default courses;
